import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function WebsitePage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="website-wrapper">
        <div className="website-wrapper-inner">
          <Helmet>
            <title>Welcome - Arture.dev</title>
            <meta
              name="description"
              content="Welcome to Arture.dev management portal"
            />
          </Helmet>

          <div className="website-hero">
            <div className="website-hero-content">
              <h1 className="white text-white">Welcome to Arture.dev</h1>
              <p className="lead">Your management portal for all services</p>

              <div className="website-hero-actions">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => navigate("/account")}
                >
                  Go to My Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
